import { formatDate } from 'shared/lib/formatDate';
import { adaptationRoute, requestSalaryRoute, reviewProcessRoute, sendFeedbackRoute, sendReviewRoute } from 'shared/routes';
import { definitions } from 'shared/types/APISchema';
import { getLinkForExternalFeedbackForm } from 'shared/ui/GenerateExternalFeedbackLink/lib/getLinkForExternalFeedbackForm';

import { AdaptationFeedbackTodo } from '../ui/AdaptationFeedbackTodo';
import { DefaultTodoItem } from '../ui/DefaultTodoItem';
import { TodoItemContent } from '../ui/TodoItemContent';
import { TodoListItem } from '../ui/TodoListItem';
import { TodoListItemForContest } from '../ui/TodoListItemForContest';

type Props = {
  item: definitions['MinEmployeeTodoTask'];
  isLoading?: boolean;
};

export const getComponentByTodoType = ({ item, isLoading }: Props) => {
  switch (item.type) {
    case 'CLOSE_SALARY_REQUEST':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Закрыть заявку на ЗП сотрудника: '
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={requestSalaryRoute}
            params={item?.extraData?.salaryRequestId?.toString()}
          />
        </TodoListItem>
      );
    case 'SOFT_SKILL_FEEDBACK':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Оставить обратную связь на сотрудника: '
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={sendFeedbackRoute}
            params={item?.extraData?.softSkillProcessId?.toString()}
          />
        </TodoListItem>
      );
    case 'REVIEW_FEEDBACK':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Оставить ревью на сотрудника: '
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={sendReviewRoute}
            params={item?.extraData?.reviewRequestId?.toString()}
          />
        </TodoListItem>
      );
    case 'REVIEWER_MANUAL_ASSIGNMENT':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Назначить ревьюера вручную на сотрудника: '
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={reviewProcessRoute}
            params={item?.extraData?.reviewProcessId?.toString()}
          />
        </TodoListItem>
      );
    case 'SELF_SOFT_SKILL_FEEDBACK':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Оценить свои софт-скиллы'
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={sendFeedbackRoute}
            params={item?.extraData?.softSkillProcessId?.toString()}
          />
        </TodoListItem>
      );
    case 'CHANGE_ADAPTATION_STATUS':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Поменять статус адаптации на сотрудника: '
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={adaptationRoute}
            params={item?.extraData?.adaptationId}
          />
        </TodoListItem>
      );
    case 'ASSIGN_EXTERNAL_EVALUATOR':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Назначить внешнего оценивающего для сотрудника: '
            title={item?.title}
            link={getLinkForExternalFeedbackForm(item?.extraData?.softSkillProcessId)}
            date={formatDate(item?.deadline)}
          />
        </TodoListItem>
      );
    case 'FILL_PROFILE':
      return (
        <TodoListItemForContest
          id={item.extraData.employeeId}
          link={item.extraData.contestLink}
          item={item}
          isLoading={isLoading}
          isCompleted={item?.completed}
        />
      );
    case 'CONDUCT_INTRODUCTORY_MEETING_MANAGER':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Проведи вводную встречу новичку '
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={adaptationRoute}
            params={item?.extraData?.adaptationProcessId?.toString()}
          />
        </TodoListItem>
      );
    case 'CONDUCT_INTRODUCTORY_MEETING_MENTOR':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Познакомься и расскажи что ждёт новичка '
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={adaptationRoute}
            params={item?.extraData?.adaptationProcessId?.toString()}
          />
        </TodoListItem>
      );
    case 'COLLECT_FEEDBACKS_MENTOR':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <AdaptationFeedbackTodo
            title={item?.title}
            date={formatDate(item?.deadline)}
            checkpointEnd={item?.extraData?.checkpointEnd}
            checkpointNumber={item?.extraData?.checkpointNumber}
            managerName={item?.extraData?.managerName}
          />
        </TodoListItem>
      );
    case 'COLLECT_FEEDBACKS_MANAGER':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <AdaptationFeedbackTodo
            title={item?.title}
            date={formatDate(item?.deadline)}
            checkpointEnd={item?.extraData?.checkpointEnd}
            checkpointNumber={item?.extraData?.checkpointNumber}
            mentorName={item?.extraData?.mentorName}
          />
        </TodoListItem>
      );
    case 'PROTECTION_ADAPTATION_COORDINATOR':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Поставь защиту новичку '
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={adaptationRoute}
            params={item?.extraData?.adaptationProcessId?.toString()}
          />
        </TodoListItem>
      );
    case 'CHANGE_CHECKPOINT_STATUS':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text={item?.extraData?.customCheckpointMessage}
            date={formatDate(item?.deadline)}
            route={adaptationRoute}
            params={item?.extraData?.adaptationProcessId?.toString()}
          />
        </TodoListItem>
      );
    case 'CONGRATULATE_EMPLOYEE_ADAPTATION_SUCCESS':
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <TodoItemContent
            text='Поздравь с окончанием испытательного срока сотрудника '
            title={item?.title}
            date={formatDate(item?.deadline)}
            route={adaptationRoute}
            params={item?.extraData?.adaptationProcessId?.toString()}
          />
        </TodoListItem>
      );
    default:
      return (
        <TodoListItem item={item} isCompleted={item?.completed} isLoading={isLoading}>
          <DefaultTodoItem title={item?.title} />
        </TodoListItem>
      );
  }
};
